import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./hooks/useAuth";
import AppRoutes from "./routes/AppRoutes";
import { TooltipProvider } from "./components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

function App() {
	const queryClient = new QueryClient(queryOptions);

	return (
		<QueryClientProvider client={queryClient}>
			<AuthProvider>
				<TooltipProvider>
					<BrowserRouter>
						<AppRoutes />
					</BrowserRouter>
				</TooltipProvider>
			</AuthProvider>
		</QueryClientProvider>
	);
}

const queryOptions = {
	defaultOptions: {
		queries: {
			retry: (failureCount: number, error: Error) => {
				if ("errorType" in error) {
					// Si no tenemos permisos/auth, no merece la pena estar tirando queries
					if (error.errorType === "UNAUTHORIZED") return false;
					if (error.errorType === "AUTH_ERROR") return false;
					if (error.errorType === "FORBIDDEN") return false;
				}

				return true;
			},
		},
	},
};

export default App;
